import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchApplicationTypes = () => {
        return network.api('get', '/wasa/application-types');
    }

    const fetchFormFields = (applicationType) => {
        return network.api('get', '/wasa/form-fields?application_type=' + applicationType);
    }

    const submitGeneralApplication = (data) => {
        return network.api('post', '/wasa/general-application-submit', data);
    }

    const fetchPendingGeneralApplications = (query) => {
        return network.api('get', '/wasa/pending-general-applications' + query);
    }

    const fetchPendingGeneralApplication = (id) => {
        return network.api('get', '/wasa/pending-general-applications/' + id);
    }

    const acceptGeneralApplication = (id, data) => {
        return network.api('post', '/wasa/pending-general-applications/' + id + '/accept', data);
    }

    const rejectGeneralApplication = (id, data) => {
        return network.api('post', '/wasa/pending-general-applications/' + id + '/reject', data);
    }

    return {
        fetchApplicationTypes,
        fetchFormFields,
        submitGeneralApplication,
        fetchPendingGeneralApplications,
        fetchPendingGeneralApplication,
        acceptGeneralApplication,
        rejectGeneralApplication,
    }
}
